/* eslint-disable camelcase */
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { GeoMapperData, GeoMapperItem } from '../types/geo-mapper.types';

const geoMapperEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeoMapperItems: builder.query<GeoMapperItem[], void>({
      query: () => ({
        method: 'GET',
        url: 'b2b/geo_mapper',
      }),
      transformResponse(response: InvisiblyApiResponse<GeoMapperItem[]>) {
        return response.item;
      },
    }),
    getGeoMapperItem: builder.query<GeoMapperData, {id: string}>({
      query: ({id}) => ({
        method: 'GET',
        url: `b2b/geo_mapper/${id}`,
      }),
      transformResponse(response: InvisiblyApiResponse<GeoMapperData>) {
        return response.item;
      },
    }),
    uploadFile: builder.mutation<GeoMapperItem, {file: File}>({
      query: ({ file }) => {
        const fd = new FormData();
        console.log('uploading file', file);
        fd.append("file", file, file.name);
        return { url: 'b2b/geo_mapper', method: 'POST', data: fd };
      },
      transformResponse(response: InvisiblyApiResponse<GeoMapperItem>) {
        return response.item; // Return first item since we expect a single ProcessResponse
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetGeoMapperItemQuery,
  useGetGeoMapperItemsQuery,
  useUploadFileMutation,
} = geoMapperEndpoints;